import React from 'react';
import Img from '../../../../../components/Img/Img';
import Modal from '../../../../../components/Modal';
import PreviewTagTrendKeywordTagListItem from '../../PreviewTagTrendKeywordTagListItem';
import './PreviewTagTrendKeywordModal.scss';

const PreviewTagTrendKeywordModal = (props) => {
  const { isOpen, closeModal, data } = props;
  const { tagTrendKeywordPreviewData } = data;
  const { tagTopRankList, tagStyleList, tagCollectionList } = tagTrendKeywordPreviewData;

  return (
    <Modal
      title={'태그 트렌드 키워드 미리보기'}
      wrapClassName="preview-tag-trend-keyword-modal-wrapper"
      isOpen={isOpen}
      width={377}
      height={700}
      padding={'0px'}
      isFooter={false}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="preview-tag-trend-keyword-modal-wrap">
        <div className="follow-recommend-message-section">
          <div className="main-message">#태그</div>
          <div className="main-message">팔로우해보세요!</div>
          <div className="sub-message">태그를 팔로우하면 연관 상품을 추천해드려요.</div>
        </div>

        <div className="tag-top-rank-list-section">
          <div className="tag-top-rank-list">
            {tagTopRankList.map((item) => (
              <PreviewTagTrendKeywordTagListItem key={item.id} tagItem={item} />
            ))}
          </div>
        </div>

        <div className="tag-style-list-section">
          <div className="tag-trend-keyword-section-title">스타일별 태그</div>

          <div className="tag-style-list">
            {tagStyleList.map((item) => (
              <div className="tag-style-item" key={item.id}>
                <Img className="tag-img" clickAble={false} src={item.url ? item.url : ''} />

                <div className="tag-name">#{item.name}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="tag-collection-list-section">
          <div className="tag-trend-keyword-section-title">태그 모아보기</div>

          <div className="tag-collection-list">
            {tagCollectionList.map((item) => (
              <PreviewTagTrendKeywordTagListItem key={item.id} tagItem={item} />
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PreviewTagTrendKeywordModal;
